const t = (e) => e.table;
export {
  t as selectTable
};
//# sourceMappingURL=selectors.js.map
